import filterAPI from "../api/filterAPI";
import { ActionTypesScreen7 } from "app/constants";

export function fetchBarChartDataScreen7(county, occupation) {
  return (dispatch) => {
    filterAPI
      .getBarChartDataScreen7({ county: county, occupation: occupation })
      .then((res) => {
        let barChartData = res.data.data;
        dispatch(handleBarChartDataScreen7(barChartData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleBarChartDataScreen7(data) {
  return {
    type: ActionTypesScreen7.GET_BAR_CHART_SCREEN7,
    payload: data,
  };
}

export function fetchFeederDataScreen7(county, occupation) {
  return (dispatch) => {
    filterAPI
      .getFeederDataScreen7({ county: county, occupation: occupation })
      .then((res) => {
        let feederData = res.data.data;
        dispatch(handleFeederDataScreen7(feederData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleFeederDataScreen7(data) {
  return {
    type: ActionTypesScreen7.GET_FEEDERS_DATA_SCREEN7,
    payload: data,
  };
}

export function fetchLeftMenuDataScreen7(county, occupation) {
  return (dispatch) => {
    filterAPI
      .getLeftMenuDataScreen7({ county: county, occupation: occupation })
      .then((res) => {
        let leftMenuData = res.data.data;
        dispatch(handleLeftMenuDataScreen7(leftMenuData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleLeftMenuDataScreen7(data) {
  return {
    type: ActionTypesScreen7.GET_LEFT_MENU_DATA_SCREEN7,
    payload: data,
  };
}

export function fetchTreeMapDataScreen7(socRef, socTarget) {
  return (dispatch) => {
    filterAPI
      .getTreeMapDataScreen7({ soc_ref: socRef, soc_target: socTarget })
      .then((res) => {
        let treeMapData = res.data.data;
        dispatch(handleTreeMapDataScreen7(treeMapData));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleTreeMapDataScreen7(data) {
  return {
    type: ActionTypesScreen7.GET_TREE_MAP_DATA_SCREEN7,
    payload: data,
  };
}
